import { createFileRoute, Outlet } from "@tanstack/react-router";
import { validateOnboardingSearch } from "./-search-params";

/**
 * Pathless layout route for onboarding screens.
 * Groups: start, what-you-need, impact, info, peer-info
 */
export const Route = createFileRoute("/$locale/$partner/_onboarding")({
	validateSearch: validateOnboardingSearch,
	component: OnboardingLayout,
});

function OnboardingLayout() {
	return <Outlet />;
}
